import React from 'react';
import { useTranslation } from 'react-i18next';
import './EcosystemCrossLink.css';

export function navigateSpa(path) {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

const WELLNESS_STORE_CATEGORIES = new Set([
  'productos-naturales',
  'bienestar',
  'combos',
]);

export function TiendaServicesCrossLink() {
  const { t } = useTranslation();
  const pills = [
    { path: '/bienestar/yoga', labelKey: 'ecosystemCrosslink.pillYoga', icon: 'spa' },
    { path: '/bienestar/entrenamiento', labelKey: 'ecosystemCrosslink.pillTraining', icon: 'dumbbell' },
    { path: '/bienestar/conecta', labelKey: 'ecosystemCrosslink.pillConecta', icon: 'brain' },
  ];

  return (
    <section className="eco-crosslink eco-crosslink--tienda" aria-labelledby="eco-tienda-title">
      <div className="eco-crosslink-inner">
        <div className="eco-crosslink-copy">
          <p className="eco-crosslink-kicker">{t('ecosystemCrosslink.tiendaKicker')}</p>
          <h2 id="eco-tienda-title" className="eco-crosslink-title">{t('ecosystemCrosslink.tiendaTitle')}</h2>
          <p className="eco-crosslink-lead">{t('ecosystemCrosslink.tiendaLead')}</p>
          <button type="button" className="eco-crosslink-cta" onClick={() => navigateSpa('/servicios')}>
            {t('ecosystemCrosslink.tiendaCta')}
            <i className="fas fa-arrow-right" aria-hidden="true" />
          </button>
        </div>
        <nav className="eco-crosslink-pills" aria-label={t('ecosystemCrosslink.tiendaPillsLabel')}>
          {pills.map((pill) => (
            <button
              key={pill.path}
              type="button"
              className="eco-crosslink-pill"
              onClick={() => navigateSpa(pill.path)}
            >
              <i className={`fas fa-${pill.icon}`} aria-hidden="true" />
              <span>{t(pill.labelKey)}</span>
            </button>
          ))}
          <button type="button" className="eco-crosslink-pill eco-crosslink-pill--muted" onClick={() => navigateSpa('/servicios#bienestar-experiencias')}>
            <i className="fas fa-compass" aria-hidden="true" />
            <span>{t('ecosystemCrosslink.pillHub')}</span>
          </button>
        </nav>
      </div>
    </section>
  );
}

export function ServiciosStoreAside() {
  const { t } = useTranslation();

  return (
    <aside className="eco-crosslink eco-crosslink--servicios" aria-labelledby="eco-servicios-store-title">
      <div className="eco-crosslink-inner eco-crosslink-inner--aside">
        <div className="eco-crosslink-icon" aria-hidden="true">
          <i className="fas fa-seedling" />
        </div>
        <div className="eco-crosslink-copy">
          <h2 id="eco-servicios-store-title" className="eco-crosslink-title eco-crosslink-title--sm">
            {t('ecosystemCrosslink.serviciosStoreTitle')}
          </h2>
          <p className="eco-crosslink-lead">{t('ecosystemCrosslink.serviciosStoreLead')}</p>
          <button
            type="button"
            className="eco-crosslink-cta eco-crosslink-cta--outline"
            onClick={() => navigateSpa('/tienda?category=productos-naturales')}
          >
            {t('ecosystemCrosslink.serviciosStoreCta')}
            <i className="fas fa-arrow-right" aria-hidden="true" />
          </button>
        </div>
      </div>
    </aside>
  );
}

export function ProductWellnessCrossLink({ category }) {
  const { t } = useTranslation();
  const slug = (category || '').trim().toLowerCase().replace(/\s+/g, '-');
  if (!WELLNESS_STORE_CATEGORIES.has(slug)) return null;

  return (
    <aside className="eco-crosslink eco-crosslink--product" aria-labelledby="eco-product-wellness-title">
      <p className="eco-crosslink-kicker">{t('ecosystemCrosslink.productKicker')}</p>
      <h2 id="eco-product-wellness-title" className="eco-crosslink-title eco-crosslink-title--sm">
        {t('ecosystemCrosslink.productTitle')}
      </h2>
      <p className="eco-crosslink-lead">{t('ecosystemCrosslink.productLead')}</p>
      <div className="eco-crosslink-product-actions">
        <button type="button" className="eco-crosslink-cta" onClick={() => navigateSpa('/bienestar/yoga')}>
          {t('ecosystemCrosslink.productCtaYoga')}
        </button>
        <button type="button" className="eco-crosslink-link" onClick={() => navigateSpa('/servicios#bienestar-experiencias')}>
          {t('ecosystemCrosslink.productCtaHub')}
        </button>
      </div>
    </aside>
  );
}
